/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check

export * from '@bottlebooks/gatsby-theme-event/src/components/Brand/PresentedBrands';

export default function PresentedBrands() {
  return null;
}
